module.exports = __webpack_public_path__ + "static/media/PR.b47acc3b.png";